import { useContext } from 'react';

import { BreadcrumbContext } from '../../app/BreadcrumbProvider';
import BreadcrumbItem from '../../components/Breadcrumb/BreadcrumbItem';
import Breadcrumb from '../../components/Breadcrumb/index';
import { selectCurrentCourse } from '../../db/courses/selectors';
import { useAppSelector } from '../../store/hooks';

const useQuizAnalyticsBreadcrumbVM = () => {
  const currentCourse = useAppSelector((state) => selectCurrentCourse(state));
  const isCurrentCourseArchived = Boolean(currentCourse?.status.isArchived);

  const { breadcrumbItems } = useContext(BreadcrumbContext);

  return { breadcrumbItems, isCurrentCourseArchived };
};

const QuizAnalyticsBreadcrumb = () => {
  const { breadcrumbItems, isCurrentCourseArchived } = useQuizAnalyticsBreadcrumbVM();

  return (
    <Breadcrumb pageTitle={breadcrumbItems.quizAnalytics}>
      <BreadcrumbItem item={breadcrumbItems.home} />
      {isCurrentCourseArchived && <BreadcrumbItem item={breadcrumbItems.archived} />}
      <BreadcrumbItem item={breadcrumbItems.course} />
      <BreadcrumbItem item={breadcrumbItems.class} />
      <BreadcrumbItem item={breadcrumbItems.quiz} />
    </Breadcrumb>
  );
};

export default QuizAnalyticsBreadcrumb;
